import gql from "graphql-tag"
import RoomStatusBsr from "."
import moment from "moment"
import { connect } from "react-redux"
import {
  getMatchFromRouter,
  getEntityTypeMapping,
} from "../../helpers/sharedHelperFunctions"
import { GRAPHQL_DATE_FORMAT } from "../../helpers/sharedConstants"
import { graphqlDynamic } from "react-apollo-dynamic-query"

const generateQuery = ({ entityType }) => gql`
  query RoomStatusBsr(
    $entityID: ID!
    $shiftIds: [ID!]
    $startAt: String!
    $endAt: String!
  ) {
    entity: ${entityType}(id: $entityID) {
      id
      shiftAssignments: shiftAssignments(
        ids: $shiftIds
        startAt: $startAt
        endAt: $endAt
      ) {
        id
        primaryRoles
        secondaryRoles
        roundingPeriodMinutes
        compliancePercentage
        longestGap
        startsAt
        endsAt
        beginningShiftChange {
          complianceMet
          currentBsrComplianceDurationSeconds
          bsrStartsAt
          duration
        }
        endingShiftChange {
          complianceMet
          currentBsrComplianceDurationSeconds
          bsrStartsAt
          duration
        }
        rounds {
          startsAt
          endsAt
          compliant
          visits {
            edges {
              node {
                user {
                  name
                }
                healthcareRole {
                  name
                }
                duration
                entry {
                  capturedAt
                }
              }
            }
          }
        }
      }
    }
  }
`

const roleClassMapping = (role, primaryRoles, secondaryRoles) => {
  if (primaryRoles.find(r => r === role)) {
    return "primary"
  } else if (secondaryRoles.find(r => r === role)) {
    return "secondary"
  } else {
    return "unknown"
  }
}

const RoomStatusWithApollo = graphqlDynamic(generateQuery, {
  options: ({ entityID, shiftAssignmentId, startDate, endDate }) => ({
    variables: {
      entityID,
      shiftIds: [shiftAssignmentId],
      startAt: moment(startDate).format(GRAPHQL_DATE_FORMAT),
      endAt: moment(endDate).format(GRAPHQL_DATE_FORMAT),
    },
  }),
  props: ({ data: { error, loading, entity } }) => {
    if (error) {
      throw error
    }

    if (loading) {
      return { loading, shiftAssignments: [] }
    }

    if (!entity) {
      throw Error("404")
    }

    // Should only get 1 shiftAssignment since we're only giving one ID in query
    const shiftAssignment = { ...entity.shiftAssignments[0] }

    // Remap the visits into the rounds to simplify the structure and add role info
    shiftAssignment.rounds = shiftAssignment.rounds.map(round => {
      round.userVisits = round.visits.edges.map(edge => {
        if (!edge.node) return {}
        return {
          userName: edge.node.user.name,
          userHealthcareRoleName: edge.node.healthcareRole.name,
          userHealthcareRoleType: roleClassMapping(
            edge.node.healthcareRole.name,
            shiftAssignment.primaryRoles,
            shiftAssignment.secondaryRoles
          ),
          visitDuration: edge.node.duration,
          entry: edge.node.entry.capturedAt,
        }
      })
      return round
    })

    return {
      loading,
      shiftAssignment,
    }
  },
})(RoomStatusBsr)

const RoomStatusBsrWithData = connect(({ router }) => {
  const match = getMatchFromRouter(router)
  return {
    entityType: getEntityTypeMapping(match.params.entityType).singularField,
    entityID: match.params.entityId,
  }
})(RoomStatusWithApollo)

export default RoomStatusBsrWithData
